import {
  LOGGER_LOG,
  LOGGER_ERROR,
  EVENT_FAILED_PROMISE,
  EVENT_ROUTE_CHANGED,
} from "./constants";
// @ts-ignore
import { log, error } from "./actions";
import { ROUTE_PUSHED } from "../route/reducer";
import { makeSimpleId } from "../../../utils";
import { AnyAction, Middleware } from "redux";
import { AppStore } from "../../../store";

const sessionId = makeSimpleId();

export const crashReporterMiddleware: Middleware = (
  store: AppStore,
) => next => action => {
  const v = next(action);
  if (isLoggerAction(action)) {
    return v;
  }
  if (action.type === ROUTE_PUSHED) {
    setTimeout(
      () => store.dispatch(log(EVENT_ROUTE_CHANGED, "1", action.payload, true)),
      0,
    );
  }
  if (v && v.then && v.catch) {
    return v.then(null, (err: Error) => {
      store.dispatch(error(EVENT_FAILED_PROMISE, null, JSON.stringify(err)));
      throw err;
    });
  }
  return v;
};

export const logInfoMiddleware: Middleware = (
  store: AppStore,
) => next => action => {
  if (!isLoggerAction(action)) {
    return next(action);
  }
  const state = store.getState();
  return next({
    ...action,
    payload: {
      ...action.payload,
      route: state.route,
      msg: `${state.user.email || ""}/${sessionId} ${action.payload.msg}`,
    },
  });
};

function isLoggerAction(action: AnyAction): boolean {
  return action.type === LOGGER_LOG || action.type === LOGGER_ERROR;
}
